import React, { ReactElement } from 'react'
import mapValues from 'lodash/mapValues'

import { FeatureFlagsContext } from '../context'
import {
  FeatureFlagName,
  FeatureFlags,
  DEFAULT_FEATURE_FLAGS,
} from '../feature-flags'
import { getClientConfigBool } from '../helpers/config-helper'

const flagValuesFromEnv = mapValues(FeatureFlagName, getClientConfigBool)

interface FfProps {
  children: ReactElement
  doGetFromEnv?: boolean
  overrides?: Partial<FeatureFlags>
}

export default function FeatureFlagsProvider({
  children,
  doGetFromEnv,
  overrides,
}: FfProps): ReactElement {
  const baseValues = doGetFromEnv ? flagValuesFromEnv : DEFAULT_FEATURE_FLAGS
  const flagValues = Object.assign({}, baseValues, overrides)
  return (
    <FeatureFlagsContext.Provider value={flagValues}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}
